export const LcpDisclaimer = () => (
  <p className="text-[#2B2F2D] text-micro leading-relaxed w-full text-left">
    Fair is a Claims Management Company (CMC). You can claim for free, without using a CMC, first to
    your finance provider or to the FOS/FSCS. The FCA has introduced a free to use motor finance
    redress scheme.
    <br />
    <br />
    *The FCA has estimated &pound;829 will be the average refund per motor finance agreement under
    the redress scheme and our average client has 2 claims. Redress depends on individual
    circumstances and eligibility.
    <br />
    <br />
    <span className="text-primary font-black">IMPORTANT:</span> Do not have more than one
    representative acting on the same claim. This can cause delays and may result in fees from both
    firms.
  </p>
);
